import { Divider } from '@material-ui/core';
import FormText from '../components/FormText/FormText';
import InputFileUploadSingle from '../components/Inputs/InputFileUploadSingle/InputFileUploadSingle';
import InputFileUploadSingleWithWebcam from '../components/Inputs/InputFileUploadSingleWithWebcam/InputFileUploadSingleWithWebcam';
import InputCheckbox from '../components/Inputs/InputCheckbox/InputCheckbox';
import InputSelect from '../components/Inputs/InputSelect/InputSelect';
import InputSelectCountry from '../components/Inputs/InputSelectCountry/InputSelectCountry';
import InputSelectCountryOrWrite from '../components/Inputs/InputSelectCountryOrWrite/InputSelectCountryOrWrite';
import InputRadio from '../components/Inputs/InputRadio/InputRadio';
import InputText from '../components/Inputs/InputText/InputText';
import InputSwitch from '../components/Inputs/InputSwitch/InputSwitch';
import InputDatePicker from '../components/Inputs/InputDatePicker/InputDatePicker';
import InputPhoneNumber from '../components/Inputs/InputPhoneNumber/InputPhoneNumber';
import InputNationalityCountry from '../components/Inputs/InputSelectNationality/InputSelectNationality';
import BulletList from '../components/BulletList/BulletList';
import SamplePhotos from '../components/SamplePhotos/SamplePhotos';
import InputSelectCountryState from '../components/Inputs/InputSelectCountryState/InputSelectCountryState';
import InputTextArea from '../components/Inputs/InputTextArea/InputTextArea';
import InputMultiSelect from '../components/Inputs/InputMultiSelect/InputMultiSelect';
import InputTags from '../components/Inputs/InputTags/InputTags';
import ReadOnlyText from '../components/Inputs/ReadOnlyText/ReadOnlyText';

export enum FORM_FIELD_TYPE_CODE {
  DROPDOWN = 'DROPDOWN',
  COUNTRY_SELECT = 'COUNTRY_SELECT',
  COUNTRY_SELECT_OR_WRITE = 'COUNTRY_SELECT_OR_WRITE',
  TEXTFIELD = 'TEXTFIELD',
  EMAIL = 'EMAIL',
  RADIO_BUTTONS = 'RADIO_BUTTONS',
  TOGGLE_BUTTON = 'TOGGLE_BUTTON',
  FILE_UPLOAD_SINGLE = 'FILE_UPLOAD_SINGLE',
  FILE_UPLOAD_SINGLE_WITH_WEBCAM = 'FILE_UPLOAD_SINGLE_WITH_WEBCAM',
  DATE_PICKER = 'DATE_PICKER',
  CHECKBOX = 'CHECKBOX',
  PHONE_NUMBER = 'PHONE_NUMBER',
  NATIONALITY_SELECT = 'NATIONALITY_SELECT',
  TEXTAREA = 'TEXTAREA',
  STATE_SELECT = 'STATE_SELECT',
  EVENT_MULTI_SELECT = 'EVENT_MULTI_SELECT',
  STATE_MULTI_SELECT = 'STATE_MULTI_SELECT',
  NATIVE_RESIDENT_SELECT = 'NATIVE_RESIDENT_SELECT',
  INPUT_TAGS = 'INPUT_TAGS',
  READ_ONLY_TEXT = 'READ_ONLY_TEXT'
}

const INPUT_ELEMENTS: Dict<React.FC<any>> = {
  DROPDOWN: InputSelect,
  TEXTFIELD: InputText,
  EMAIL: InputText,
  RADIO_BUTTONS: InputRadio,
  TOGGLE_BUTTON: InputSwitch,
  FILE_UPLOAD_SINGLE: InputFileUploadSingle,
  FILE_UPLOAD_SINGLE_WITH_WEBCAM: InputFileUploadSingleWithWebcam,
  DATE_PICKER: InputDatePicker,
  CHECKBOX: InputCheckbox,
  PHONE_NUMBER: InputPhoneNumber,
  COUNTRY_SELECT: InputSelectCountry,
  COUNTRY_SELECT_OR_WRITE: InputSelectCountry,
  NATIONALITY_SELECT: InputNationalityCountry,
  TEXTAREA: InputTextArea,
  STATE_SELECT: InputSelectCountryState,
  EVENT_MULTI_SELECT: InputMultiSelect,
  STATE_MULTI_SELECT: InputMultiSelect,
  NATIVE_RESIDENT_SELECT: InputSelect,
  INPUT_TAGS: InputTags,
  READ_ONLY_TEXT: ReadOnlyText
};

const TEXT_ELEMENTS: Dict<React.FC<any>> = {
  SECTION_TEXT: FormText,
  SUBSECTION_TEXT: FormText,
  SECTION_HEADER: FormText,
};

const OTHER_ELEMENTS: Dict<React.FC<any>> = {
  DIVIDER: Divider,
  BULLET_LIST: BulletList,
  SAMPLE_PHOTOS: SamplePhotos,
};

const INPUT_TYPES: Dict<FORM_FIELD_TYPE_CODE> = {
  DROPDOWN: FORM_FIELD_TYPE_CODE.DROPDOWN,
  COUNTRY_SELECT: FORM_FIELD_TYPE_CODE.COUNTRY_SELECT,
  COUNTRY_SELECT_OR_WRITE: FORM_FIELD_TYPE_CODE.COUNTRY_SELECT_OR_WRITE,
  TEXTFIELD: FORM_FIELD_TYPE_CODE.TEXTFIELD,
  EMAIL: FORM_FIELD_TYPE_CODE.EMAIL,
  RADIO_BUTTONS: FORM_FIELD_TYPE_CODE.RADIO_BUTTONS,
  TOGGLE_BUTTON: FORM_FIELD_TYPE_CODE.TOGGLE_BUTTON,
  FILE_UPLOAD_SINGLE: FORM_FIELD_TYPE_CODE.FILE_UPLOAD_SINGLE,
  FILE_UPLOAD_SINGLE_WITH_WEBCAM: FORM_FIELD_TYPE_CODE.FILE_UPLOAD_SINGLE_WITH_WEBCAM,
  DATE_PICKER: FORM_FIELD_TYPE_CODE.DATE_PICKER,
  CHECKBOX: FORM_FIELD_TYPE_CODE.CHECKBOX,
  PHONE_NUMBER: FORM_FIELD_TYPE_CODE.PHONE_NUMBER,
  NATIONALITY_SELECT: FORM_FIELD_TYPE_CODE.NATIONALITY_SELECT,
  TEXTAREA: FORM_FIELD_TYPE_CODE.TEXTAREA,
  STATE_SELECT: FORM_FIELD_TYPE_CODE.STATE_SELECT,
  EVENT_MULTI_SELECT: FORM_FIELD_TYPE_CODE.EVENT_MULTI_SELECT,
  STATE_MULTI_SELECT: FORM_FIELD_TYPE_CODE.STATE_MULTI_SELECT,
  NATIVE_RESIDENT_SELECT: FORM_FIELD_TYPE_CODE.NATIVE_RESIDENT_SELECT,
  INPUT_TAGS: FORM_FIELD_TYPE_CODE.INPUT_TAGS,
  READ_ONLY_TEXT:FORM_FIELD_TYPE_CODE.READ_ONLY_TEXT
};

const ELEMENT_TYPES = {
  BULLET_LIST: 'BULLET_LIST',
  SAMPLE_PHOTOS: 'SAMPLE_PHOTOS',
};

const TEXT_TYPES: Dict<string> = {
  SECTION_TEXT: 'TEXT_SECTION',
  SUBSECTION_TEXT: 'TEXT_SUBSECTION',
  SECTION_HEADER: 'SECTION_HEADER',
};

export { INPUT_ELEMENTS, TEXT_ELEMENTS, OTHER_ELEMENTS, INPUT_TYPES, TEXT_TYPES, ELEMENT_TYPES };
